import React from "react";

import Login from "./Login";
import MyTools from "./MyTools";
import BoeiWidget from "../components/BoeiWidget";

function Home({ isLoggedIn, setIsLoggedIn, setError, error }) {
  return isLoggedIn ? (
    <>
      <BoeiWidget />
      <MyTools setIsLoggedIn={setIsLoggedIn} setError={setError} />
    </>
  ) : (
    <Login setIsLoggedIn={setIsLoggedIn} setError={setError} error={error} />
  );
}

export default Home;
